module.exports = __webpack_public_path__ + "img/neo.72c96c47.svg";